export type HourlyTagCategory =
  | "BREAK"
  | "WORK"
  | "DELAY"
  | "EARLY_DEPARTURE"
  | "RCR";

export function canAppearInTemplate(
  category: HourlyTagCategory | undefined,
): boolean {
  return [undefined, "WORK", "BREAK"].includes(category);
}

export function getSchedulableCategories(): (undefined | HourlyTagCategory)[] {
  return [undefined, "WORK", "BREAK", "RCR"];
}
